import { WEBSHOP_BASE_URL } from 'constants/index'

export const getWebshopUrl = path => WEBSHOP_BASE_URL.replace(/\/$/, '') + '/' + path.replace(/^\//, '')
